import * as actions from "./actions";
import initialState from "./initialState";
import reducer from "./reducer";

export const authActions = actions;
export const authInitialState = initialState;
export const authReducer = reducer;
